import { getUserRegion } from '@frontend/components/agromarket/components/RegionSelector'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { isSuccess } from '@/api/helpers'
import { getProduct } from '@/api/kubik/inputs-catalog/clients/axios/getProduct'
import type { IThunkProps } from '@/redux/interfaces'
import { ClientIdCookieService } from '@/services'
import { agriculturalProductRequestFailed, agriculturalProductRequestFinished, agriculturalProductRequestStarted } from './actions'
import type { IFetchAgriculturalProductPayload } from './types'

export const fetchAgriculturalProduct = createAsyncThunk<unknown, IFetchAgriculturalProductPayload, IThunkProps>(
  '@@agriculturalProduct/FETCH_PRODUCT',
  async (payload, thunkAPI) => {
    const { dispatch } = thunkAPI
    const clientId = ClientIdCookieService.get()
    const headers: Record<string, string> = { 'uniq-id': clientId }

    const { userRegion } = getUserRegion()

    if (!payload.token) {
      console.warn('SSR needs token to fetch agricultural product')
    }

    if (payload.token) {
      headers['Authorization'] = `Bearer ${payload.token}`
    }

    const { productId } = payload.params || {}
    dispatch(agriculturalProductRequestStarted(productId))

    const response = await getProduct({ id: productId, regionCode: userRegion.code }, { headers })

    if (!isSuccess(response) || !response.data) {
      dispatch(agriculturalProductRequestFailed(response, productId))

      return
    }

    dispatch(agriculturalProductRequestFinished(response.data))
  },
)
